import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('userId');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  signup: (email, username, password) =>
    api.post('/auth/signup', { email, username, password }),
  login: (email, password) =>
    api.post('/auth/login', { email, password }),
  verifyEmail: (token) =>
    api.post('/auth/verify-email', { token }),
  forgotPassword: (email) =>
    api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) =>
    api.post('/auth/reset-password', { token, password }),
  refreshToken: () =>
    api.post('/auth/refresh-token')
};

export const userAPI = {
  getProfile: () =>
    api.get('/users/profile'),
  updateProfile: (data) =>
    api.put('/users/profile', data),
  searchUsers: (q) =>
    api.get(`/users/search?q=${q}`),
  getUser: (id) =>
    api.get(`/users/${id}`)
};

export const contactAPI = {
  getContacts: () =>
    api.get('/contacts'),
  addFriend: (targetUserId, message) =>
    api.post('/contacts/add-friend', { targetUserId, message }),
  getPendingRequests: () =>
    api.get('/contacts/friend-requests/pending'),
  acceptRequest: (id) =>
    api.post(`/contacts/friend-requests/${id}/accept`),
  rejectRequest: (id) =>
    api.post(`/contacts/friend-requests/${id}/reject`),
  removeContact: (contactId) =>
    api.delete(`/contacts/${contactId}`)
};

export default api;
